{
  "version": 1,
  "asset_id": "b52cf7d8-b91b-4abd-90f3-c24084b3732d",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/b52cf7d8-b91b-4abd-90f3-c24084b3732d/lecanto-metal-roof-before-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/b52cf7d8-b91b-4abd-90f3-c24084b3732d/lecanto-metal-roof-before-480w.webp",
  "original_filename": "lecanto-metal-roof-before-480w.webp",
  "size": 60700,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
